import ResponsiveMenuWrapper from './ResponsiveMenuWrapper';

export default ResponsiveMenuWrapper;
